'use client';

import * as Dialog from '@radix-ui/react-dialog';

import { DialogOverlay } from '@eliadmin/core/src/components/dlz/dialogs/dialog-overlay';
import Link from '@eliadmin/core/src/components/link';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

export const FAVORITES_SIGN_IN_DIALOG = 'FAVORITES_SIGN_IN_DIALOG';

/**
 * „Prihláste sa“ (Figma 60152:16868, phones 60438:88634): shown to a guest who clicks the favourite
 * button while the store keeps favourites for signed-in customers only. Opened through the core
 * dialog store.
 */
export function FavoritesSignInDialog() {
  const { t } = useTranslations();

  return (
    <Dialog.Portal>
      <DialogOverlay />
      <Dialog.Content className="fixed left-1/2 top-1/2 z-[200] flex w-[calc(100%-32px)] max-w-[539px] -translate-x-1/2 -translate-y-1/2 flex-col items-center gap-6 rounded-[18px] bg-white px-4 py-6 text-center shadow-[0_8px_24px_-4px_rgba(15,16,18,0.08),0_2px_4px_rgba(15,16,18,0.06)] focus:outline-none data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95 motion-reduce:animate-none sm:px-6">
        <div className="flex flex-col gap-3">
          <Dialog.Title className="dlz-h2 text-[#0F1012]">{t('text357')}</Dialog.Title>
          <Dialog.Description className="dlz-body-m text-[#4F545C]">
            Pre pridanie produktu do obľúbených je potrebné prihlásenie do vytvoreného účtu.
          </Dialog.Description>
        </div>
        <div className="flex w-full flex-col gap-3 sm:w-auto sm:flex-row">
          <Button asChild className="h-12 sm:h-[52px]">
            <Link href={ROUTES.PROFILE()} prefetch={false}>
              {t('text189')}
            </Link>
          </Button>
          <Button asChild variant="secondary" className="h-12 sm:h-[52px]">
            <Link href={ROUTES.REGISTER()} prefetch={false}>
              {t('text758')}
            </Link>
          </Button>
        </div>
      </Dialog.Content>
    </Dialog.Portal>
  );
}

FavoritesSignInDialog.id = FAVORITES_SIGN_IN_DIALOG;
